/** @jsx jsx */
import React, { useState, useEffect, useContext } from "react";
import { LogoImage, NavLinks } from "@/data";
import { Col, Container, Row } from "react-bootstrap";
import { SearchContext } from "@/context/search-context";
import { MenuContext } from "@/context/menu-context";
import { Link } from "gatsby";
import { jsx } from '@emotion/react'

import Instagram from '@/images/LP-arabe/instagram.svg'
import Facebook from '@/images/LP-arabe/facebook.svg'

import {
  header,
  logo,
  mainMenu,
  submenu,
  navigator,
  socialMedia,
  desktop,
  mobile
} from '../assets/styles/Header.styles'
import { useMediaQuery } from 'react-responsive';

const HeaderOne = () => {
  const [sticky, setSticky] = useState(false);
  const { searchStatus, updateSearchStatus } = useContext(SearchContext);
  const { menuStatus, updateMenuStatus } = useContext(MenuContext)
  const isMobile = useMediaQuery({
    query: '(max-width: 850px)'
  })

  const handleSearchClick = e => {
    e.preventDefault();
    updateSearchStatus(!searchStatus);
  }
  const handleMenuClick = e => {
    e.preventDefault();
    updateMenuStatus(!menuStatus);
  }

  const handleScroll = () => {
    if (window.scrollY > (isMobile ? 100 : 700)) {
      setSticky(true);
    } else if (window.scrollY < (isMobile ? 100 : 700)) {
      setSticky(false);
    }
  }

  useEffect(() => {
    window.addEventListener("scroll", handleScroll);
    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, [sticky]);

  return (
    <header css={header}
      className={`${true === sticky ? "fixedHeader" : null
        }`}
      id="header"
    >

      <Container>
        <div className="bg-menu">
          <Row className="justify-content-between">
            <Col className="col-6" lg={2} md={3} sm={3}>
              <div css={logo}>
                <Link to="/">
                  <img src={LogoImage.light} alt="Educação que prepara para liderar e prosperar" title="Educação que prepara para liderar e prosperar" />
                </Link>
              </div>
            </Col>
            <Col lg={8} sm={8} md={7} xs={7} className="d-none d-lg-block ">
              <nav css={mainMenu} className="text-center">
                <ul>
                  {NavLinks.map((links, index) => {
                    return (
                      <li
                        key={index}
                        className={`${undefined !== links.subItems
                            ? "menu-item-has-children"
                            : ""
                          }`}
                      >
                        <Link to={links.url}>{links.name}</Link>
                        {undefined !== links.subItems ? (
                          <ul css={submenu} className="sub-menu">
                            {links.subItems.map((subLinks, index) => (
                              <li key={index}>
                                <Link to={subLinks.url}>{subLinks.name}</Link>
                              </li>
                            ))}
                          </ul>
                        ) : null}
                      </li>
                    );
                  })}
                </ul>
              </nav>
            </Col>
            <Col css={socialMedia} lg={2} sm={6} md={3} xs={3}>
              <nav className='nav-social'>
                <a href="https://www.instagram.com/escolaarabebertoni/" target='_blank'>
                  <img src={Instagram} alt="Instagram" />
                </a>
                <a href="https://www.facebook.com/EscolaArabeBertoni/" target='_blank'>
                  <img src={Facebook} alt="Facebook" />
                </a>
              </nav>
            </Col>
            <Col css={mobile} lg={2} md={2} sm={4} xs={2}>
              <div css={navigator} className="text-right">

                <a
                  href="#"
                  className="menu mobilemenu d-none d-md-none d-lg-none"
                >
                  <i className="mei-menu"></i>
                </a>
                <a
                  id="open-overlay-nav"
                  className="menu hamburger"
                  onClick={handleMenuClick}
                  href="#"
                >
                  <i className="mei-menu"></i>
                </a>
              </div>
            </Col>
          </Row>
        </div>
      </Container>
    </header>
  );
};

export default HeaderOne;